import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useState } from "react";
import { Button, List, SearchInput, SelectInput, TopToolbar, useTranslate } from "react-admin";

import { ROWS_PER_PAGE } from "../constants";
import { useLocationFilterContext } from "../hooks/useLocationFilterContext";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { DeviceDataGrid } from "./DeviceDataGrid";
import { DeviceEnrollmentSection } from "./deviceEnrollment/DeviceEnrollmentSection";
import { DEVICE_ENROLLMENT_STATUS_CHOICES } from "./deviceEnrollment/deviceEnrollmentStatusChoices";
import { EmptyList } from "./EmptyList";
import { ListTitle } from "./ListTitle";

const DeviceListActions = ({ disabled, onCreateClick }: { disabled: boolean; onCreateClick: () => void }) => {
  const translate = useTranslate();

  return (
    <TopToolbar>
      <Button
        label={translate("deviceEnrollment.section.createButton")}
        variant="contained"
        disabled={disabled}
        onClick={onCreateClick}
        data-testid="device-enrollment-create-button"
      >
        <Add />
      </Button>
    </TopToolbar>
  );
};

export const DeviceList = () => {
  const translate = useTranslate();
  const { organizationId: selectedOrganizationId } = useOrganizationContext();
  const { locationId: selectedLocationId } = useLocationFilterContext();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const handleCreateClick = () => setIsCreateDialogOpen(true);
  const handleCreateClose = () => setIsCreateDialogOpen(false);

  return (
    <>
      <List
        resource="Device"
        title={<ListTitle title="Geräte" />}
        filters={[
          <SearchInput key="search" source="search" alwaysOn />,
          <SelectInput
            key="enrollmentStatus"
            source="enrollmentStatus"
            label={translate("status")}
            choices={DEVICE_ENROLLMENT_STATUS_CHOICES}
            emptyText="deviceStatus.ALL"
            alwaysOn
          />,
        ]}
        filter={{ organizationId: selectedOrganizationId, locationId: selectedLocationId }}
        actions={<DeviceListActions disabled={!selectedOrganizationId} onCreateClick={handleCreateClick} />}
        empty={
          <EmptyList
            image="/images/device.svg"
            description={translate("emptyList.device.description")}
            createButton={{
              label: translate("deviceEnrollment.section.createButton"),
              onClick: handleCreateClick,
              disabled: !selectedOrganizationId,
            }}
          />
        }
        perPage={ROWS_PER_PAGE}
      >
        <DeviceDataGrid />
      </List>
      <Box sx={{ mt: 4 }}>
        <DeviceEnrollmentSection
          organizationId={selectedOrganizationId}
          createDialogControl={{ open: isCreateDialogOpen, onClose: handleCreateClose }}
        />
      </Box>
    </>
  );
};
